import { createQueryHook } from "@accurx/api/QueryClient";
import { IsUserRequiredToMapWorkspaceResponse } from "@accurx/api/account";
import { httpClient2 } from "@accurx/shared";

export const WORKSPACE_REQUIRES_TO_BE_MAPPED =
    "WorkspaceRequiresToBeMappedByUser";

export const useWorkspaceRequiresToBeMappedByUser = createQueryHook(
    ({
        workspaceId,
        enabled = false,
    }: {
        workspaceId: number | null;
        enabled: boolean;
    }) => ({
        queryKey: [WORKSPACE_REQUIRES_TO_BE_MAPPED, { workspaceId }],
        queryFn: async () => {
            if (!workspaceId) {
                throw new Error(
                    "No workspaceId to check if user is required to map a workspace",
                );
            }

            const response = await httpClient2
                .get({
                    path: `/api/account/WorkspaceMapping/isUserRequiredToMapWorkspace?organisationId=${workspaceId}`,
                })
                .json<IsUserRequiredToMapWorkspaceResponse>();

            return response.isUserRequiredToMapWorkspace;
        },
        enabled,
    }),
);
